import { render, staticRenderFns } from "./big-screen.vue?vue&type=template&id=1f04a1e2&"
import script from "./big-screen.vue?vue&type=script&lang=js&"
export * from "./big-screen.vue?vue&type=script&lang=js&"
import style0 from "./big-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports